import type { Messages } from "../catalogue.en";

export const finance: Partial<Messages> = {
  "finance.priceList.loading": "טוען את המחירון",
  "finance.priceList.forbidden": "אין לך הרשאה לקרוא את מחירון המרפאה.",
  "finance.priceList.actions": "פעולות",
  "finance.priceLists.subtitle": "רשימות מחירים של המרפאה בשמן; מחיר שירות נרשם במחירון ברירת המחדל.",
  "finance.priceLists.tableLabel": "מחירונים",
  "finance.priceLists.column.name": "מחירון",
  "finance.priceLists.column.default": "ברירת מחדל",
  "finance.priceLists.column.branches": "סניפים",
  "finance.priceLists.column.state": "מצב",
  "finance.priceLists.defaultBadge": "מחירון ברירת המחדל",
  "finance.priceLists.wholeClinic": "כל המרפאה",
  "finance.priceLists.active": "פעיל",
  "finance.priceLists.archived": "בארכיון",
  "finance.priceLists.openNamed": "הגדרות של {name}",
  "finance.priceLists.makeDefaultNamed": "להפוך את {name} למחירון ברירת המחדל",
  "finance.priceLists.madeDefault": "{name} הוא כעת מחירון ברירת המחדל.",
  "finance.priceLists.loadFailed": "לא ניתן היה לטעון את המחירונים.",
  "finance.priceLists.empty": "אין מחירונים",
  "finance.priceLists.emptyDetail": "הוסיפו מחירון, או רשמו מחיר ראשון לשירות תחת «שירותים»: מחירון ברירת המחדל של המרפאה יופיע יחד איתו.",
  "finance.priceLists.emptyDetailReader": "עדיין לא נוצר מחירון.",
  "finance.priceLists.readOnly": "ניתן לקרוא את המחירונים; לשינוי נדרשת הרשאת ניהול מחירונים.",
  "finance.priceList.title": "מחירון",
  "finance.priceList.new": "מחירון חדש",
  "finance.priceList.name": "שם",
  "finance.priceList.branches": "סניפים",
  "finance.priceList.branchesHint": "לא סומן סניף: המחירון משרת את כל המרפאה.",
  "finance.priceList.isDefault": "מחירון ברירת המחדל",
  "finance.priceList.isDefaultHint": "מחיר של שירות חדש נרשם כאן, ומחיר שמתבקש ללא מחירון נקרא מכאן.",
  "finance.priceList.isDefaultLocked": "מחירון ברירת המחדל נשאר כזה עד שמחירון אחר יתפוס את מקומו.",
  "finance.priceList.firstIsDefault": "המחירון הראשון של המרפאה הופך לברירת המחדל שלה.",
  "finance.priceList.save": "שמירה",
  "finance.priceList.active": "פעיל",
  "finance.priceList.archived": "בארכיון",
  "finance.priceList.archive": "לארכיון",
  "finance.priceList.archiveTitle": "להעביר את המחירון לארכיון?",
  "finance.priceList.archiveDescription": "המחירון יפסיק לתמחר עבודה חדשה. מחירים שכבר נקבעו במסמכים יישארו כפי שהיו.",
  "finance.priceList.archiveConfirm": "להעביר את המחירון לארכיון",
  "finance.priceList.keepList": "להשאיר את המחירון",
  "finance.priceList.archiveLocked": "בחרו מחירון ברירת מחדל אחר לפני העברת מחירון זה לארכיון.",
  "finance.priceList.archiveDirty": "שמרו או בטלו את השינויים לפני ההעברה לארכיון.",
  "finance.priceList.archivedNote": "המחירון בארכיון: מחיריו נשמרים עבור המסמכים שקבעו אותם ואינם ניתנים לשינוי.",
  "finance.priceList.unsaved": "מחירון שלא נשמר",
  "finance.priceList.discard": "לבטל שינויים",
  "finance.priceList.reloadDiscard": "לטעון מחדש ולבטל שינויים",
  "finance.priceList.saveFailed": "לא ניתן היה לשמור את המחירון.",
  "finance.priceList.changed": "המחירון השתנה מאז שנפתח. טענו מחדש לפני השמירה.",
  "finance.priceList.invalid": "המחירון נדחה. בדקו את השם ואת הסניפים.",
  "finance.priceList.notFound": "מחירון זה אינו קיים עוד.",
  "finance.priceList.archivedRefusal": "מחירון זה בארכיון ואינו ניתן לשינוי.",
  "finance.priceList.defaultRequired": "בחרו תחילה מחירון ברירת מחדל אחר: מחירון ברירת המחדל אינו מועבר לארכיון ואינו מורד.",
  "finance.priceList.loadFailed": "לא ניתן היה לטעון את המחירון.",
  "finance.priceList.pricesLoadFailed": "לא ניתן היה לטעון את המחירים.",
  "finance.priceList.edit": "עריכת המחירון",
  "finance.priceList.tabs": "חלקי המחירון",
  "finance.priceList.pricesTab": "מחירים",
  "finance.priceList.packagesTab": "חבילות",
  "finance.priceList.onDate": "מחירים לתאריך",
  "finance.priceList.branch": "מנקודת מבט של",
  "finance.priceList.servicesLabel": "שירותים מתומחרים ב-{name}",
  "finance.priceList.column.service": "שירות",
  "finance.priceList.column.price": "מחיר",
  "finance.priceList.column.tax": "מס",
  "finance.priceList.column.from": "מ-",
  "finance.priceList.column.until": "עד",
  "finance.priceList.column.scope": "חל על",
  "finance.priceList.column.state": "מצב השירות",
  "finance.priceList.setPriceNamed": "לקבוע את המחיר של {name}",
  "finance.priceList.openPriceNamed": "מחירי {name}",
  "finance.priceList.servicesEmpty": "אין שירותים",
  "finance.priceList.servicesEmptyDetail": "צרו שירותים תחת «שירותים»; הם יופיעו כאן לתמחור.",
  "finance.priceRow.title": "מחיר",
  "finance.priceRow.inList": "במחירון {list}",
  "finance.priceRow.current": "בתאריך {date}: {price}, {scope}",
  "finance.priceRow.currentNone": "אין מחיר בתאריך {date}",
  "finance.priceRow.amount": "מחיר חדש, {currency}",
  "finance.priceRow.amountRequired": "הזינו את המחיר.",
  "finance.priceRow.scope": "חל על",
  "finance.priceRow.from": "מתאריך",
  "finance.priceRow.fromRequired": "הזינו את היום הראשון שבו המחיר חל.",
  "finance.priceRow.until": "עד תאריך, לא חובה",
  "finance.priceRow.untilHint": "היום הראשון שבו המחיר כבר אינו חל; ריק משאיר אותו ללא הגבלה.",
  "finance.priceRow.untilInvalid": "תאריך הסיום חייב להיות אחרי תאריך ההתחלה.",
  "finance.priceRow.save": "לרשום את המחיר",
  "finance.priceRow.discard": "לבטל",
  "finance.priceRow.unsaved": "מחיר שלא נרשם",
  "finance.priceRow.serviceArchived": "השירות בארכיון; מחיריו נשמרים אך לא ניתן לרשום מחיר חדש.",
  "finance.priceRow.saveFailed": "לא ניתן היה לרשום את המחיר.",
  "finance.priceRow.invalid": "המחיר נדחה. בדקו את הסכום ואת התאריכים.",
  "finance.pricePackage.title": "חבילה",
  "finance.pricePackage.new": "חבילה חדשה",
  "finance.pricePackage.name": "שם",
  "finance.pricePackage.lines": "שירותים בחבילה",
  "finance.pricePackage.service": "שירות",
  "finance.pricePackage.chooseService": "בחרו שירות",
  "finance.pricePackage.quantity": "יחידות",
  "finance.pricePackage.addLine": "להוסיף שירות",
  "finance.pricePackage.allAdded": "כל השירותים המתומחרים של המחירון כבר בחבילה.",
  "finance.pricePackage.removeLine": "להסיר שורה {position}",
  "finance.pricePackage.linesRequired": "ציינו לפחות שירות מתומחר אחד עם מספר היחידות.",
  "finance.pricePackage.nonePriced": "עדיין אין שירות מתומחר במחירון זה; חבילה כוללת רק שירותים מתומחרים.",
  "finance.pricePackage.save": "לרשום את החבילה",
  "finance.pricePackage.discard": "לבטל",
  "finance.pricePackage.unsaved": "חבילה שלא נרשמה",
  "finance.pricePackage.saveFailed": "לא ניתן היה לרשום את החבילה.",
  "finance.pricePackage.invalid": "החבילה נדחתה. בדקו את התאריכים, השירותים וההתאמות.",
  "finance.pricePackage.tableLabel": "חבילות של {name}",
  "finance.pricePackage.column.name": "חבילה",
  "finance.pricePackage.column.lines": "שירותים",
  "finance.pricePackage.column.state": "מצב",
  "finance.pricePackage.line": "{name} × {quantity}",
  "finance.pricePackage.empty": "אין חבילות",
  "finance.pricePackage.emptyDetail": "חבילה מאגדת שירותים מתומחרים של מחירון זה לרכישה מראש.",
  "finance.pricePackage.retractNamed": "למשוך את {name}",
  "finance.pricePackage.retractTitle": "למשוך את החבילה?",
  "finance.pricePackage.retractDescription": "{name} לא יוצע עוד. רכישות שכבר בוצעו ממנו שומרות על הראיות שלהן.",
  "finance.pricePackage.retractConfirm": "למשוך",
  "finance.pricePackage.keep": "להשאיר את החבילה",
  "finance.pricePackage.retractFailed": "לא ניתן היה למשוך את החבילה.",

  "finance.services.title": "שירותים שבוצעו",
  "finance.services.subtitle":
    "שירותים שאושרו לרשומת EMR זו והחיובים הקפואים שלהם.",
  "finance.services.loading": "טוען שירותים שבוצעו",
  "finance.services.loadFailed": "לא ניתן לטעון את השירותים שבוצעו.",
  "finance.services.tableLabel": "שירותים שבוצעו עבור רשומת EMR זו",
  "finance.services.empty": "לא נרשמו שירותים",
  "finance.services.emptyDetail": "שירותים שאושרו עבור רשומה זו יופיעו כאן.",
  "finance.services.noMatches": "אין שירותים שמתאימים למסננים",
  "finance.services.noMatchesDetail":
    "הרחב או נקה את מסנני העמודות כדי לחזור לכל השירותים שבוצעו.",
  "finance.services.column.service": "שירות",
  "finance.services.column.code": "קוד",
  "finance.services.column.quantity": "כמות",
  "finance.services.column.charge": "חיוב",
  "finance.services.column.performed": "נרשם",
  "finance.services.column.serviceDate": "תאריך השירות",
  "finance.serviceCorrection.action": "תיקון {name}",
  "finance.serviceCorrection.title": "תיקון שירות שבוצע",
  "finance.serviceCorrection.units": "יחידות מקוריות לביטול",
  "finance.serviceCorrection.unit": "יחידה {number}",
  "finance.serviceCorrection.correctedUnit": "יחידה {number} (כבר בוטלה)",
  "finance.serviceCorrection.reason": "סיבה",
  "finance.serviceCorrection.remaining": "כמות לאחר התיקון",
  "finance.serviceCorrection.postingDate": "תאריך רישום התיקון",
  "finance.serviceCorrection.portion": "התחייבות {number}",
  "finance.serviceCorrection.credit": "זיכוי",
  "finance.serviceCorrection.release": "הקצאת תשלום שיש לשחרר",
  "finance.serviceCorrection.payment": "שחרור מתשלום מתאריך {date}",
  "finance.serviceCorrection.available": "זמין לשחרור: {amount}",
  "finance.serviceCorrection.noPayout": "לא נרשם החזר כספי.",
  "finance.serviceCorrection.preview": "תצוגה מקדימה של התיקון",
  "finance.serviceCorrection.loading": "התצוגה המקדימה נטענת…",
  "finance.serviceCorrection.confirm": "אישור התיקון",
  "finance.serviceCorrection.saving": "התיקון נרשם…",
  "finance.serviceCorrection.chooseUnits": "יש לבחור את היחידות המקוריות לביטול.",
  "finance.serviceCorrection.releaseRequired": "יש להזין לכל התחייבות את סכום השחרור המדויק מהתשלומים המפורטים.",
  "finance.serviceCorrection.reasonRequired": "יש להזין סיבה באורך של שלושה תווים לפחות.",
  "finance.serviceCorrection.failed": "לא ניתן לרשום את התיקון. השינויים נשמרו בטופס.",
  "finance.serviceCorrection.periodClosed": "תקופת הרישום סגורה. יש לפתוח אותה לפני רישום התיקון.",
  "finance.serviceCorrection.provenanceRequired": "אסמכתאות הכיסוי המקוריות אינן מאפשרות את הביטול החלקי הזה.",
  "finance.serviceCorrection.sourceChanged": "השירות או מצבו הכספי השתנו. יש לטעון מחדש לפני ניסיון נוסף.",
  "finance.serviceCorrection.forbidden": "נדרשות הרשאות לתיקונים כספיים ולעריכת רשומות קליניות.",
  "finance.serviceCorrection.unsaved": "נותרו בחירות וסיבה שלא נשמרו בתיקון השירות.",
  "finance.serviceCorrection.reload": "טעינת השירות מחדש",
  "finance.serviceCorrection.reloadFailed": "לא ניתן לטעון את השירות מחדש. השינויים נשמרו בטופס.",
  "finance.serviceCorrection.reloaded": "השירות נטען מחדש. יש לבחור שוב את היחידות המקוריות שנותרו.",
  "finance.services.priceUnavailable": "לא ניתן לטעון את המחירון הנוכחי.",

  "finance.encounterServices.title": "שירותים",
  "finance.encounterServices.subtitle":
    "שירותים שבוצעו עבור רישום EMR זה והחיובים שנרשמו עבורם.",
  "finance.encounterServices.forbidden":
    "אין לך הרשאה לקרוא שירותים עבור רישום EMR זה.",
  "finance.encounterServices.loading": "טוען שירותים עבור רישום ה־EMR",
  "finance.encounterServices.loadFailed":
    "לא ניתן לטעון את השירותים עבור רישום ה־EMR.",
  "finance.encounterServices.tableLabel": "שירותים שבוצעו עבור רישום EMR זה",
  "finance.encounterServices.emptyDetail":
    "יש לבחור שירות במחירון שלצד הטבלה; הוא יירשם בכמות 1.",
  "finance.encounterServices.emptyNoRecordsDetail":
    "יש לשמור רשומת EMR לפני רישום שירות.",
  "finance.encounterServices.emptyNoPrimaryRecordDetail":
    "שירות מחויב על המסמך הראשי העדכני של הרישום, ולרישום זה אין מסמך כזה.",
  "finance.encounterServices.noPrimaryRecord":
    "לרישום EMR זה אין מסמך ראשי עדכני שניתן לחייב עליו שירות.",
  "finance.encounterServices.column.record": "רשומת EMR",
  "finance.encounterServices.recordName": "{document}, {authored}",
  "finance.encounterServices.billedOn": "מחויב על {name}",
  "finance.encounterServices.recordUnavailable": "רשומה לא זמינה",
  "finance.encounterServices.column.actions": "פעולות",

  "finance.servicePicker.title": "שירותים רפואיים",
  "finance.servicePicker.catalogueTab": "מחירון",
  "finance.servicePicker.searchPlaceholder": "שם שירות או קוד",
  "finance.servicePicker.loading": "טוען את המחירון",
  "finance.servicePicker.empty": "אין שירותים במחירון.",
  "finance.servicePicker.noMatches": "אין שירות שמתאים לחיפוש זה.",

  "finance.patient.title": "כספים",
  "finance.patient.forbidden":
    "אין לך הרשאה לקרוא את הרשומה הכספית של מטופל זה.",
  "finance.patient.forbiddenDetail": "שאר כרטיס המטופל עדיין זמין.",
  "finance.menuLabel": "מקטעי כספים",
  "finance.nav.estimates": "הערכות עלות",
  "finance.nav.estimatesDescription": "הערכות עלות טיפול למטופל",
  "finance.evidence.original": "הסכום המקורי שהופק",

  "finance.correction.reason": "סיבת התיקון",
  "finance.correction.reasonRequired": "יש להזין סיבה מפורשת לתיקון.",
  "finance.correction.stale":
    "התיעוד הכספי השתנה. יש לסגור ולפתוח מחדש את החלון כדי לבדוק את הגרסה האחרונה.",
  "finance.correction.historicalIncomplete":
    "הרשומה ההיסטורית אינה מכילה תמונת מצב חתומה מלאה, ולכן לא ניתן לתקן אותה בבטחה.",
  "finance.correction.unsavedIntent": "תיקון כספי שלא נשמר",

  // ——— סביבת העבודה הכספית: /finance ———
  "finance.workspace.title": "כספים",
  "finance.workspace.tileDescription": "חשבונות, תקבולים, שירותים ומחירים וסגירת החודש",
  "finance.workspace.areaNavigation": "מדורי הכספים",
  "finance.nav.accounts": "חשבונות חיוב",
  "finance.nav.accountsDescription": "יתרות וכספים שהתקבלו",
  "finance.nav.people": "משתתפים בתשלומים",
  "finance.nav.peopleDescription": "אנשים וארגונים המשתתפים בתשלומים",
  "finance.nav.priceLists": "מחירונים",
  "finance.nav.priceListsDescription": "מה המרפאה גובה עבור שירותיה, לפי תאריך",
  "finance.nav.taxes": "מיסים",
  "finance.nav.taxesDescription": "תנאי מס לפי תאריך שמחיר יכול לכלול",
  "finance.nav.externalCosts": "הוצאות חיצוניות",
  "finance.nav.externalCostsDescription": "קטלוג הוצאות צד שלישי לסמכי הערכת טיפול",
  "finance.nav.administration": "הגדרות כספים",
  "finance.nav.administrationDescription": "הפרופיל הכספי והתקופות החודשיות",
  "finance.nav.services": "שירותים",
  "finance.nav.servicesDescription": "מה המרפאה עושה וכמה זה עולה היום",
  "finance.clinicServices.subtitle": "כל שירותי המרפאה ומחירם להיום",
  "finance.clinicServices.tableLabel": "שירותי המרפאה",
  "finance.clinicServices.column.name": "שירות",
  "finance.clinicServices.column.source": "מקור",
  "finance.clinicServices.column.price": "מחיר להיום",
  "finance.clinicServices.column.state": "מצב",
  "finance.clinicServices.actions": "פעולות",
  "finance.clinicServices.openNamed": "פתיחת {name}",
  "finance.clinicServices.priceByBranch": "שונה לפי סניף",
  "finance.clinicServices.readOnly": "אפשר לקרוא את השירותים ואת מחיריהם, אך לא לשנותם.",
  "finance.clinicServices.loading": "טוען את השירותים",
  "finance.clinicServices.loadFailed": "לא ניתן היה לטעון את השירותים.",
  "finance.clinicServices.empty": "אין שירותים עדיין",
  "finance.clinicServices.emptyDetail": "הוסיפו את השירות הראשון שהמרפאה מספקת. המחיר אינו חובה.",
  "finance.clinicServices.emptyDetailReader": "עדיין לא הוגדר שירות שהמרפאה מספקת.",
  "finance.clinicServices.noDefaultList": "המחירים אינם מוצגים: למרפאה כמה מחירונים ואף אחד מהם אינו ברירת המחדל. בחרו אחד במדור המחירונים.",
  "finance.clinicService.title": "שירות במרפאה",
  "finance.clinicService.new": "שירות חדש",
  "finance.clinicService.source": "מקור השירות",
  "finance.clinicService.custom": "בשם שנתנה המרפאה",
  "finance.clinicService.terminology": "ממילון השירותים הרפואיים",
  "finance.clinicService.search": "חיפוש במילון השירותים הרפואיים",
  "finance.clinicService.conceptRequired": "בחרו שירות מהמילון.",
  "finance.clinicService.conceptClear": "ניקוי השירות שנבחר",
  "finance.clinicService.name": "שם השירות",
  "finance.clinicService.save": "שמירה",
  "finance.clinicService.price": "מחיר, {currency}",
  "finance.clinicService.newPrice": "מחיר חדש מהיום, {currency}",
  "finance.clinicService.priceOptional": "לכל הסניפים, מהיום. השאירו ריק כדי לשמור ללא מחיר; מחיר לסניף או לתקופה נקבע במדור המחירונים.",
  "finance.clinicService.priceInvalid": "הזינו את המחיר בספרות, עד {scale} ספרות אחרי הסימן העשרוני של המרפאה.",
  "finance.clinicService.priceList": "מחירון",
  "finance.clinicService.priceListDefault": "{list} — ברירת המחדל",
  "finance.clinicService.priceListEvery": "לכל המחירונים",
  "finance.clinicService.priceListHint": "המחיר יירשם במחירון הזה. בחירה בכל המחירונים תרשום את אותו מחיר בכל אחד מהם.",
  "finance.clinicService.priceInList": "המחיר יירשם במחירון {list}.",
  "finance.clinicService.priceFirstList": "למרפאה אין עדיין מחירון: המחיר הזה ייצור את מחירון ברירת המחדל.",
  "finance.clinicService.priceListFailed": "המחיר לא נרשם במחירון {list}.",
  "finance.clinicService.tax": "מס",
  "finance.clinicService.noTax": "ללא מס",
  "finance.clinicService.history": "מחירים",
  "finance.clinicService.historyLoading": "טוען את המחירים",
  "finance.clinicService.historyLoadFailed": "לא ניתן היה לטעון את המחירים.",
  "finance.clinicService.historyEmpty": "טרם נקבע מחיר.",
  "finance.clinicService.pricesInList": "המחירים של {name} במחירון {list}",
  "finance.clinicService.pastPricesInList": "מחירים קודמים של {name} במחירון {list}",
  "finance.clinicService.pastPrices": "מחירים קודמים",
  "finance.clinicService.noCurrentPrices": "אין מחיר שתקף היום.",
  "finance.clinicService.priceSince": "מ־{from}",
  "finance.clinicService.priceBetween": "מ־{from} עד {until}",
  "finance.clinicService.allBranches": "כל הסניפים",
  "finance.clinicService.rowLive": "בתוקף",
  "finance.clinicService.rowFuture": "עתידי",
  "finance.clinicService.rowEnded": "הסתיים",
  "finance.clinicService.rowRetracted": "בוטל",
  "finance.clinicService.retractNamed": "ביטול המחיר {price} מתאריך {from}",
  "finance.clinicService.retractTitle": "לבטל את המחיר הזה?",
  "finance.clinicService.retractDescription": "המחיר {price} מתאריך {from} ייחשב כאילו לא נקבע מעולם; המחירים שהוא החליף יחזרו לתוקף. הערכות עלות שהונפקו שומרות את המחיר שבו הונפקו.",
  "finance.clinicService.retractConfirm": "ביטול המחיר",
  "finance.clinicService.keepPrice": "להשאיר את המחיר",
  "finance.clinicService.active": "פעיל",
  "finance.clinicService.archived": "בארכיון",
  "finance.clinicService.archive": "העברה לארכיון",
  "finance.clinicService.restore": "שחזור",
  "finance.clinicService.unsavedName": "שם שירות שלא נשמר",
  "finance.clinicService.unsaved": "שירות מרפאה שלא נשמר",
  "finance.clinicService.unsavedPrice": "מחיר שירות שלא נשמר",
  "finance.clinicService.discard": "ביטול השינויים",
  "finance.clinicService.reloadDiscard": "טעינה מחדש וביטול השינויים",
  "finance.clinicService.saveFailed": "לא ניתן היה לשמור את השירות.",
  "finance.clinicService.codeConflict": "שירות עם קוד זה כבר קיים.",
  "finance.clinicService.revisionConflict": "שירות המרפאה השתנה בזמן העריכה. טענו מחדש לפני השמירה.",
  "finance.clinicService.suggestionStale": "ההצעות נוצרו לשם קודם. בקשו אותן שוב.",
  "finance.clinicService.notFound": "השירות הזה כבר אינו קיים.",
  "finance.clinicService.archivedRefusal": "אי אפשר לשנות שירות שבארכיון. שחזרו אותו תחילה.",
  "finance.clinicService.invalid": "השירות נדחה. בדקו את השם ואת המחיר.",
  "finance.clinicService.dictionaryFailed": "לא ניתן היה לטעון את מילון השירותים.",
  "finance.clinicService.dictionaryUnavailable": "מילון השירותים של המרפאה אינו משיב. בדקו את קישורי הטרמינולוגיה של המרפאה.",
  "finance.clinicService.changed": "השירות או מחיריו השתנו בינתיים. טענו מחדש לפני השמירה.",
  "finance.clinicService.listArchived": "מחירון ברירת המחדל נמצא בארכיון. שחזרו אותו או בחרו ברירת מחדל אחרת במדור המחירונים.",
  "finance.clinicService.listUnavailable": "למרפאה כמה מחירונים ואף אחד מהם אינו ברירת המחדל. בחרו אחד במדור המחירונים.",
  "finance.clinicService.priceNotFound": "המחיר הזה כבר אינו קיים. טענו מחדש.",
  "finance.clinicService.priceRetracted": "המחיר הזה כבר בוטל.",

  "finance.party.loading": "השם נטען",
  "finance.party.unavailable": "השם אינו זמין",
  "finance.party.peopleGroup": "אנשים",
  "finance.party.entitiesGroup": "ישויות משפטיות",

  "finance.accounts.title": "חשבונות חיוב",
  "finance.accounts.tableLabel": "חשבונות חיוב",
  "finance.accounts.columnOwner": "בעלים",
  "finance.accounts.columnLifecycle": "מצב",
  "finance.accounts.columnCurrency": "מטבע",
  "finance.accounts.columnCreated": "נפתח",
  "finance.accounts.lifecycleActive": "פעיל",
  "finance.accounts.lifecycleArchived": "בארכיון",
  "finance.accounts.lifecycleClosed": "סגור",
  "finance.accounts.loading": "טעינת חשבונות חיוב",
  "finance.accounts.empty": "אין עדיין חשבונות חיוב",
  "finance.accounts.emptyDetail": "החשבון הראשון נפתח בכפתור שלמעלה.",
  "finance.accounts.noMatches": "אין חשבונות מתאימים",
  "finance.accounts.noMatchesDetail": "יש לשנות או לנקות את הסינון כדי לראות חשבונות נוספים.",
  "finance.accounts.ownerFilter": "צמצום לפי בעלים",
  "finance.accounts.ownerAny": "כל בעלים",
  "finance.accounts.ownerNarrowed": "בעלים: {name}",
  "finance.accounts.ownerNarrowedClear": "הצגת כל הבעלים",
  "finance.accounts.createTitle": "פתיחת חשבון חיוב",
  "finance.accounts.createDetail": "חשבון אחד לכל בעלים, במטבע שקובע הפרופיל הכספי.",
  "finance.accounts.createSubmit": "פתיחת חשבון",
  "finance.accounts.createSubmitting": "נפתח",
  "finance.accounts.ownerField": "בעלים",
  "finance.accounts.ownerPlaceholder": "חיפוש אנשים וישויות משפטיות",
  "finance.accounts.ownerRequired": "יש לבחור את בעלי החשבון.",
  "finance.accounts.createUnsaved": "חשבון חיוב שטרם נפתח",
  "finance.accounts.createUnsavedDetail": "הבעלים שנבחרו יימחקו.",
  "finance.accounts.failed": "לא ניתן להשלים את הפעולה בחשבון החיוב.",
  "finance.accounts.exists": "לצד הזה כבר יש חשבון חיוב. יש לפתוח את החשבון הקיים.",
  "finance.accounts.conflict": "החשבון השתנה בזמן העבודה. יש לקרוא אותו שוב ולנסות שנית.",
  "finance.accounts.stateConflict": "מצב החשבון אינו מאפשר את הפעולה הזו.",
  "finance.accounts.profileUnconfigured":
    "הפרופיל הכספי טרם הוגדר. יש להגדיר אותו תחילה במדור ניהול הכספים.",
  "finance.accounts.attemptConflict":
    "הניסיון הזה כבר נשלח עם פרטים אחרים. יש לסגור את הטופס ולהתחיל מחדש.",
  "finance.accounts.forbidden": "אין לך הרשאה לפעולה הזו בחשבון חיוב.",
  "finance.accounts.invalid": "יש לבדוק את הפרטים שהוזנו.",

  "finance.account.title": "חשבון חיוב",
  "finance.account.loading": "החשבון נטען",
  "finance.account.loadFailed": "לא ניתן לטעון את החשבון.",
  "finance.account.factsLabel": "פרטי החשבון",
  "finance.account.changeLifecycle": "שינוי מצב",
  "finance.account.positionTitle": "תמונת מצב",
  "finance.account.positionLoading": "חישוב תמונת המצב",
  "finance.account.positionFailed": "לא ניתן לחשב את תמונת המצב.",
  "finance.account.positionAsOf": "נכון ל־{date}",
  "finance.account.bucketReceivable": "לגבייה",
  "finance.account.bucketPendingConfirmation": "ממתין לאישור",
  "finance.account.bucketDisputed": "במחלוקת",
  "finance.account.bucketAvailableFunds": "כספים זמינים",
  "finance.account.bucketPrepaidValue": "ערך ששולם מראש",
  "finance.account.lifecycleTitle": "שינוי מצב החשבון",
  "finance.account.lifecycleDetail": "יש לציין את המצב החדש של החשבון ואת הסיבה.",
  "finance.account.lifecycleField": "מצב חדש",
  "finance.account.lifecycleSubmit": "שינוי מצב",
  "finance.account.lifecycleSubmitting": "משתנה",
  "finance.account.lifecycleUnsaved": "שינוי מצב שטרם נשלח",
  "finance.account.reasonField": "סיבה",
  "finance.account.reasonRequired": "יש לציין סיבה.",

  "finance.receipts.title": "תקבולים",
  "finance.receipts.tableLabel": "תקבולים",
  "finance.receipts.record": "רישום תקבול",
  "finance.receipts.columnCashDate": "תאריך קבלה",
  "finance.receipts.columnRemitter": "משלם",
  "finance.receipts.columnMethod": "אמצעי",
  "finance.receipts.columnAmount": "סכום",
  "finance.receipts.columnAvailable": "זמין",
  "finance.receipts.columnRecorded": "נרשם",
  "finance.receipts.loading": "טעינת תקבולים",
  "finance.receipts.loadFailed": "לא ניתן לטעון את התקבולים.",
  "finance.receipts.empty": "אין עדיין תקבולים",
  "finance.receipts.emptyDetail": "כספים שיתקבלו לחשבון הזה יופיעו כאן.",
  "finance.receipts.methodCash": "מזומן",
  "finance.receipts.methodCard": "כרטיס",
  "finance.receipts.methodBankTransfer": "העברה בנקאית",
  "finance.receipts.methodOther": "אחר",
  "finance.receipts.recordTitle": "רישום תקבול",
  "finance.receipts.recordDetail": "כספים שהתקבלו לחשבון הזה, בדיוק כפי שהתקבלו.",
  "finance.receipts.recordSubmit": "רישום תקבול",
  "finance.receipts.recordSubmitting": "נרשם",
  "finance.receipts.remitterField": "משלם",
  "finance.receipts.remitterPlaceholder": "חיפוש אנשים וישויות משפטיות",
  "finance.receipts.remitterRequired": "יש לבחור מי שילם את הכסף.",
  "finance.receipts.amountField": "סכום",
  "finance.receipts.amountRequired": "יש להזין את הסכום שהתקבל.",
  "finance.receipts.methodField": "אמצעי תשלום",
  "finance.receipts.branchField": "סניף מקבל",
  "finance.receipts.branchRequired": "יש לבחור את הסניף המקבל.",
  "finance.receipts.branchesFailed": "לא ניתן לטעון את הסניפים.",
  "finance.receipts.cashDateField": "תאריך קבלה",
  "finance.receipts.evidenceField": "אסמכתה",
  "finance.receipts.evidenceRequired": "יש לציין אסמכתה לתקבול — קבלה, העברה או הפניית קופה.",
  "finance.receipts.reasonField": "סיבה",
  "finance.receipts.reasonRequired": "יש לציין סיבה.",
  "finance.receipts.unsavedIntent": "תקבול שטרם נרשם",
  "finance.receipts.unsavedDetail": "התקבול שהוזן יימחק.",
  "finance.receipts.reload": "קריאת החשבון מחדש",
  "finance.receipts.reloadFailed": "לא ניתן לקרוא את החשבון מחדש.",
  "finance.receipts.reloaded": "החשבון נקרא מחדש. יש לבדוק את הטיוטה ולשלוח אותה.",
  "finance.receipts.digestTitle": "תקבול",
  "finance.receipts.postingDate": "תאריך רישום",
  "finance.receipts.journalTransaction": "תנועת יומן",
  "finance.receipts.evidenceDigest": "טביעת האסמכתה",
  "finance.receipts.beneficiaryRestricted": "מוגבל לטובת מטופל אחד.",
  "finance.receipts.failed": "לא ניתן לרשום את התקבול.",
  "finance.receipts.conflict":
    "החשבון השתנה בזמן העבודה. יש לקרוא אותו מחדש ולשלוח את התקבול שוב.",
  "finance.receipts.accountStateConflict": "תקבולים נרשמים רק לחשבון פעיל.",
  "finance.receipts.periodClosed":
    "התקופה הכספית של תאריך הקבלה הזה סגורה. יש לפתוח אותה מחדש בניהול הכספים או לבחור תאריך אחר.",
  "finance.receipts.amountInvalid": "לא ניתן לקרוא את הסכום. יש להזין אותו בתבנית המספרים של המרפאה.",
  "finance.receipts.amountOverflow": "הסכום גדול מדי.",
  "finance.receipts.currencyMismatch": "מטבע הסכום אינו תואם את מטבע החשבון.",
  "finance.receipts.attemptConflict":
    "הניסיון הזה כבר נשלח עם פרטים אחרים. יש לסגור את הטופס ולהתחיל מחדש.",
  "finance.receipts.forbidden": "אין לך הרשאה לרשום תקבולים.",
  "finance.receipts.invalid": "יש לבדוק את פרטי התקבול שהוזנו.",

  "finance.people.title": "משתתפים בתשלומים",
  "finance.people.tableLabel": "משתתפים בתשלומים",
  "finance.people.loading": "טעינת המשתתפים בתשלומים",
  "finance.people.empty": "אין עדיין משתתפים בתשלומים",
  "finance.people.emptyDetail": "ניתן להוסיף אדם או ארגון קיימים, או לרשום זהות חדשה.",
  "finance.people.noMatches": "אין אנשים מתאימים",
  "finance.people.noMatchesDetail": "יש לשנות את החיפוש כדי לראות אנשים נוספים.",
  "finance.people.registerTitle": "רישום אדם פיננסי",
  "finance.people.registerDetail": "אדם שבבעלותו חשבונות או שמשלם כספים, ששמו נכתב בשפתו.",
  "finance.people.registerSubmit": "רישום",
  "finance.people.registerSubmitting": "נרשם",
  "finance.people.registerUnsaved": "אדם פיננסי שטרם נרשם",
  "finance.people.registerUnsavedDetail": "השמות שהוזנו יימחקו.",
  "finance.people.reasonField": "סיבה",
  "finance.people.reasonRequired": "יש לציין סיבה.",
  "finance.people.languageField": "שפה עיקרית",
  "finance.people.participationTitle": "השתתפות",
  "finance.people.participationFailed": "לא ניתן לטעון את ההשתתפות.",
  "finance.people.participationUnsaved": "שינוי השתתפות שטרם נשלח",
  "finance.people.active": "משתתף",
  "finance.people.withdrawn": "הוצא",
  "finance.people.withdraw": "הוצאה",
  "finance.people.reinstate": "השבה",
  "finance.people.namesTitle": "שמות",
  "finance.people.namesLoading": "טעינת השמות",
  "finance.people.namesFailed": "לא ניתן לטעון את השמות.",
  "finance.people.namesUnsaved": "שינויי שמות שלא נשמרו",
  "finance.people.reload": "קריאה מחדש",
  "finance.people.reloadFailed": "לא ניתן לקרוא מחדש.",
  "finance.people.reloaded": "נקרא מחדש. יש לבדוק את הטיוטה ולשמור.",
  "finance.people.failed": "לא ניתן להשלים את הפעולה באדם הפיננסי.",
  "finance.people.conflict":
    "רשומת האדם הזה השתנתה בזמן העבודה. יש לקרוא אותה מחדש ולנסות שנית.",
  "finance.people.attemptConflict":
    "הניסיון הזה כבר נשלח עם פרטים אחרים. יש לסגור את הטופס ולהתחיל מחדש.",
  "finance.people.forbidden": "אין לך הרשאה לפעולה הזו באנשים פיננסיים.",
  "finance.people.invalid": "יש לבדוק את הפרטים שהוזנו.",

  "finance.administration.title": "הגדרות כספים",
  "finance.administration.profileTitle": "פרופיל כספי",
  "finance.administration.profileLoading": "הפרופיל נטען",
  "finance.administration.profileLoadFailed": "לא ניתן לטעון את הפרופיל.",
  "finance.administration.unconfigured":
    "הפרופיל הכספי אינו מוגדר. עד שיוגדר אי אפשר לפתוח חשבון או לרשום כספים.",
  "finance.administration.unconfiguredDetail": "ההגדרה דורשת הרשאת ניהול פרופיל.",
  "finance.administration.configure": "הגדרת הפרופיל",
  "finance.administration.configureTitle": "הגדרת הפרופיל הכספי",
  "finance.administration.configureDetail": "מטבע המרפאה והיום שבו הוא נכנס לתוקף.",
  "finance.administration.configureSubmit": "הגדרה",
  "finance.administration.configureSubmitting": "מוגדר",
  "finance.administration.configureUnsaved": "הגדרת פרופיל שטרם נשלחה",
  "finance.administration.configureUnsavedDetail": "ההגדרה שהוזנה תימחק.",
  "finance.administration.currency": "מטבע",
  "finance.administration.currencyField": "מטבע",
  "finance.administration.currencyRequired": "יש לבחור מטבע.",
  "finance.administration.currenciesFailed": "לא ניתן לטעון את קטלוג המטבעות.",
  "finance.administration.effectiveFrom": "בתוקף מ־",
  "finance.administration.effectiveFromField": "בתוקף מ־",
  "finance.administration.effectiveFromRequired": "יש לבחור את היום שבו הפרופיל נכנס לתוקף.",
  "finance.administration.reasonField": "סיבה",
  "finance.administration.reasonRequired": "יש לציין סיבה.",
  "finance.administration.operatingEntity": "ישות משפטית מפעילה",
  "finance.administration.recordedAt": "נרשם",
  "finance.administration.reload": "קריאה מחדש",
  "finance.administration.reloadFailed": "לא ניתן לקרוא מחדש.",
  "finance.administration.reloaded": "נקרא מחדש. יש לבדוק את המצב ולנסות שנית.",
  "finance.administration.profileFailed": "לא ניתן לשמור את הפרופיל.",
  "finance.administration.profileUnconfigured": "אין פרופיל שמכסה את התאריך הזה.",
  "finance.administration.profileConflict":
    "הפרופיל השתנה בזמן ההגדרה. יש לקרוא אותו מחדש ולבדוק את הגרסה שבתוקף.",
  "finance.administration.currencyLocked":
    "מטבע המרפאה כבר נקבע על ידי כספים שנרשמו ואינו יכול להשתנות.",
  "finance.administration.attemptConflict":
    "הניסיון הזה כבר נשלח עם פרטים אחרים. יש לסגור את הטופס ולהתחיל מחדש.",
  "finance.administration.profileForbidden": "אין לך הרשאה לנהל את הפרופיל הכספי.",
  "finance.administration.profileInvalid": "יש לבדוק את ההגדרה שהוזנה.",
  "finance.administration.periodsTitle": "תקופות כספיות",
  "finance.administration.monthField": "חודש",
  "finance.administration.periodLoading": "התקופה נטענת",
  "finance.administration.periodLoadFailed": "לא ניתן לטעון את התקופה.",
  "finance.administration.open": "החודש פתוח — אפשר לרשום אליו כספים.",
  "finance.administration.closed": "החודש סגור — אי אפשר לרשום אליו כספים.",
  "finance.administration.changedAt": "השינוי האחרון {time}.",
  "finance.administration.closePeriod": "סגירת החודש",
  "finance.administration.reopenPeriod": "פתיחת החודש מחדש",
  "finance.administration.periodUnsaved": "שינוי תקופה שטרם נשלח",
  "finance.administration.periodFailed": "לא ניתן לשנות את התקופה.",
  "finance.administration.periodConflict":
    "התקופה השתנתה בזמן העבודה. יש לקרוא אותה מחדש ולנסות שנית.",
  "finance.administration.periodStateConflict": "התקופה כבר במצב הזה.",
  "finance.administration.periodForbidden": "אין לך הרשאה לסגור או לפתוח תקופות.",
  "finance.administration.periodInvalid": "יש לבדוק את הפרטים שהוזנו.",
  "finance.serviceEntry.date": "תאריך מתן השירות",
  "finance.serviceEntry.postingDate": "תאריך רישום כספי",
  "finance.serviceEntry.list": "מחירון",
  "finance.serviceEntry.chooseList": "בחירת מחירון",
  "finance.serviceEntry.account": "חשבון חיוב",
  "finance.serviceEntry.chooseAccount": "בחירת חשבון חיוב",
  "finance.serviceEntry.accountMissing": "אין חשבון חיוב פעיל למטופל זה. יש לפנות למפעיל הכספים לפתיחת חשבון.",
  "finance.serviceEntry.chooseService": "יש לבחור מחירון ושירות.",
  "finance.serviceEntry.dateQuantityRequired": "יש להזין תאריך שירות וכמות בין 1 ל־100.",
  "finance.serviceEntry.reason": "הערה לאישור השירות",
  "finance.serviceEntry.reasonRequired": "יש להזין הערה באורך של לפחות 3 תווים.",
  "finance.serviceEntry.preview": "בדיקת החיוב",
  "finance.serviceEntry.confirm": "אישור השירות והחיוב",
  "finance.serviceEntry.loading": "מחשב את החיוב…",
  "finance.serviceEntry.saving": "רושם את השירות…",
  "finance.serviceEntry.gross": "חיוב כולל מס",
  "finance.serviceEntry.net": "חיוב לפני מס",
  "finance.serviceEntry.tax": "מס כלול",
  "finance.serviceEntry.unsaved": "שירות וחיוב שטרם אושרו",
  "finance.serviceEntry.failed": "לא ניתן לרשום את השירות. הנתונים שהוזנו נשמרו.",
  "finance.serviceEntry.profileMissing": "הפרופיל הכספי של המרפאה טרם הוגדר.",
  "finance.serviceEntry.periodClosed": "התקופה הכספית של תאריך השירות סגורה.",
  "finance.serviceEntry.currencyMismatch": "המחירון והחשבון שנבחרו משתמשים בהגדרות מטבע שונות.",
  "finance.serviceEntry.changed": "הרשומה, החשבון או פרסום המחירים השתנו. יש לטעון מחדש לפני האישור.",
  "finance.serviceEntry.forbidden": "אין לך הרשאה לרשום שירותים קליניים וחיובים.",
  "finance.serviceEntry.unavailable": "מקור השירות או החשבון שנבחרו אינם זמינים.",
  "finance.serviceEntry.contextFailed": "לא ניתן לטעון את פרטי רישום השירות.",
  "finance.serviceEntry.serviceUnavailable": "השירות אינו מופיע במחירון שנבחר.",
  "finance.serviceEntry.reload": "טעינה מחדש של הפרטים",
  "finance.serviceEntry.reloadFailed": "הטעינה מחדש נכשלה. הנתונים שהוזנו נשמרו.",
  "finance.serviceEntry.reloaded": "הפרטים העדכניים נטענו. יש לבחור ולאשר שוב את השירות.",
  "finance.prepaidEntry.mode": "תשלום עבור השירות",
  "finance.prepaidEntry.selfPay": "חיוב חדש",
  "finance.prepaidEntry.prepaid": "יחידות ששולמו מראש",
  "finance.prepaidEntry.title": "מימוש שירותים ששולמו מראש",
  "finance.prepaidEntry.available": "יחידות שנרכשו וזמינות למימוש",
  "finance.prepaidEntry.chooseRange": "בחירת טווח שנרכש",
  "finance.prepaidEntry.choice": "{service} · נרכש בתאריך {date} · {range} · {price} ליחידה",
  "finance.prepaidEntry.range": "יחידות {first}–{last}",
  "finance.prepaidEntry.first": "מספר היחידה המקורית הראשונה",
  "finance.prepaidEntry.add": "הוספת היחידות שנבחרו",
  "finance.prepaidEntry.remove": "הסרת הטווח שנבחר",
  "finance.prepaidEntry.more": "יחידות זמינות נוספות",
  "finance.prepaidEntry.empty": "אין למטופל יחידות זמינות ששולמו מראש.",
  "finance.prepaidEntry.chooseUnits": "יש לבחור יחידות מקוריות שנרכשו עבור שירות זה.",
  "finance.prepaidEntry.addPending": "יש להוסיף את היחידות שנבחרו או לנקות את בחירת הטווח.",
  "finance.prepaidEntry.preview": "בדיקת המימוש",
  "finance.prepaidEntry.confirm": "אישור השירות ששולם מראש",
  "finance.prepaidEntry.loading": "בודק את היחידות שנרכשו…",
  "finance.prepaidEntry.gross": "ערך הרכישה למימוש",
  "finance.prepaidEntry.net": "ערך הרכישה לפני מס",
  "finance.prepaidEntry.unsaved": "שירות ששולם מראש וטרם אושר",
  "finance.prepaidEntry.failed": "לא ניתן לרשום את השירות ששולם מראש. הנתונים שהוזנו נשמרו.",
  "finance.prepaidEntry.readFailed": "לא ניתן לטעון את היחידות הזמינות שנרכשו.",
  "finance.prepaidEntry.periodClosed": "תקופת רישום כספית נדרשת סגורה.",
  "finance.prepaidEntry.currencyMismatch": "הגדרת המטבע של הרכישה שונה מהפרופיל הכספי של המרפאה.",
  "finance.prepaidEntry.unitsUnavailable": "היחידות שנבחרו כבר מומשו או הוחזרו. יש לרענן את הזמינות.",
  "finance.prepaidEntry.notActive": "הרכישה אינה משולמת במלואה ופעילה.",
  "finance.prepaidEntry.changed": "הרשומה, הרכישה או חשבון המקור השתנו. יש לרענן לפני האישור.",
  "finance.prepaidEntry.forbidden": "אין לך הרשאה לרשום שירותים קליניים באמצעות יחידות ששולמו מראש.",
  "finance.prepaidEntry.unavailable": "הרכישה או הרשומה הקלינית שנבחרה אינה זמינה.",
  "finance.prepaidCorrection.title": "תיקון שירות ששולם מראש",
  "finance.prepaidCorrection.gross": "הערך שיוחזר לרכישה",
  "finance.prepaidCorrection.net": "הערך שיוחזר לפני מס",
  "finance.prepaidCorrection.restored": "יחידות הרכישה שיוחזרו",
  "finance.prepaidCorrection.keepOnRecord": "אישור השירותים שנותרו ברשומה הנוכחית:",
  "finance.prepaidCorrection.confirmRetention": "יש לאשר את הרשומה הנוכחית עבור השירותים שנותרו.",
  "finance.prepaidCorrection.currentRecordRequired": "נדרשת רשומה ראשית נוכחית כדי לשמור שירותים. ביטול מלא אינו דורש רשומה חלופית.",
  "finance.prepaidCorrection.noPayout": "היחידות שבוטלו יחזרו להיות זמינות ברכישה המקורית. לא יבוצע החזר כספי.",
  "finance.prepaidCorrection.sourceChanged": "השירות המקורי, הרכישה או חשבון המקור השתנו. יש לטעון מחדש לפני האישור.",
  "finance.prepaidCorrection.unsaved": "תיקון שירות ששולם מראש שטרם אושר",
  "finance.participants.name": "שם",
  "finance.participants.person": "אדם",
  "finance.participants.organization": "ארגון",
  "finance.participants.openIdentity": "פתיחת כרטיס",
  "finance.participants.accounts": "חשבונות חיוב",
  "finance.participants.noAccounts": "אין עדיין חשבונות חיוב.",
  "finance.participants.openAccount": "פתיחת חשבון",
  "finance.participants.account": "חשבון ב־{currency}",
  "finance.participants.positionFailed": "לא ניתן לטעון את יתרות החשבון.",
  "finance.participants.add": "הוספת משתתף בתשלומים",
  "finance.participants.unsaved": "משתתף בתשלומים שלא נשמר",
  "finance.participants.newPerson": "רישום אדם חדש",
  "finance.participants.newOrganization": "רישום ארגון חדש",
  "finance.participants.back": "חזרה למשתתפים בתשלומים",
  "finance.participants.openPatient": "פתיחת כרטיס מטופל",
  "finance.participants.staffIdentity": "זהות איש צוות; לשינויים נדרשות הרשאות מתאימות.",
  "finance.participants.identityRestricted": "פרטים אישיים מנוהלים באמצעות התפקיד הקיים ובהרשאות המתאימות.",
  "finance.permissions.title": "מורשה לשלם עבור",
  "finance.permissions.loading": "טעינת הרשאת תשלום",
  "finance.permissions.failed": "לא ניתן לטעון את הרשאות התשלום.",
  "finance.permissions.empty": "אין הרשאות לשלם עבור מטופלים אחרים.",
  "finance.permissions.allowed": "בעל החשבון אישר תשלום עבור מטופל זה.",
  "finance.permissions.required": "לפני שימוש בכספים נדרשת הרשאת בעל החשבון לתשלום עבור מטופל זה.",
  "finance.permissions.manage": "פתיחת הרשאות החשבון",
  "finance.permissions.add": "רישום הרשאת בעל החשבון",
  "finance.permissions.more": "הצגת נוספים",
  "finance.permissions.patientUnavailable": "זהות המטופל אינה זמינה",
  "finance.permissions.active": "פעילה",
  "finance.permissions.revoked": "בוטלה",
  "finance.permissions.revoke": "ביטול הרשאה",
  "finance.permissions.reason": "סיבה ובסיס",
  "finance.permissions.document": "מסמך תומך {number}",
  "finance.permissions.documentFailed": "לא ניתן לקרוא את המסמכים התומכים.",
  "finance.permissions.documents": "מסמכים תומכים (לא חובה)",
  "finance.permissions.upload": "צירוף הצהרה חתומה או קבצים תומכים",
  "finance.permissions.ownerStatement": "יש לתעד את הרשאתו המפורשת של בעל החשבון לשלם עבור המטופל שנבחר. קרבה משפחתית כשלעצמה אינה הרשאה.",
  "finance.permissions.patient": "מטופל שעבורו מותר לשלם",
  "finance.permissions.save": "שמירת הרשאה",
  "finance.permissions.unsaved": "הרשאת תשלום שלא נשמרה",
  "finance.permissions.discard": "לבטל את הפרטים שלא נשמרו? מסמכים שהועלו יישארו בקובצי האדם.",
  "finance.settlement.sourceOwner": "תשלום מחשבונו של",
  "finance.settlement.sourceAccount": "חשבון מקור",
  "finance.participants.patientAccount": "חשבון המטופל",
  "finance.permissions.exists": "כבר קיימת הרשאת תשלום פעילה עבור מטופל זה.",
  "finance.permissions.accountInactive": "חשבון החיוב אינו פעיל.",
  "finance.permissions.unavailable": "החשבון, המטופל או ההרשאה אינם זמינים עוד.",
};
